import { render, staticRenderFns } from "./ProdutosCategoria.vue?vue&type=template&id=bd7240b8&scoped=true"
import script from "./ProdutosCategoria.vue?vue&type=script&lang=js"
export * from "./ProdutosCategoria.vue?vue&type=script&lang=js"
import style0 from "./ProdutosCategoria.vue?vue&type=style&index=0&id=bd7240b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7240b8",
  null
  
)

export default component.exports